import FeatureFlip from '../../Components/FeatureFlip/Projects/FeatureFlip';
export default FeatureFlip; 